import { intersection, isEmpty, flatMap } from 'lodash';

export default function getAllowedRoutes(claims, routeAccessConfig) {
  // If no claims is sent return original array, if not return array filtered by claims
  if (isEmpty(claims)) return routeAccessConfig;

  return flatMap(routeAccessConfig, function (route) {
    if (isEmpty(route.permission) || intersection(route.permission, claims).length) {
      return isEmpty(route.children)
        ? route
        : { ...route, children: getAllowedRoutes(route.children) };
    } else return [];
  });
}
